<form #targetsForm="ngForm">
  <hw-flex-editable-table
    #targetsTable
    header="mdm.obs-def-02.targets.header"
    [form]="targetsForm"
    [data]="definition.targets"
    [rowInstance]="defaultTargetRow"
    [editMode]="editMode">
    <hw-flex-editable-column title="mdm.obs-def-02.targets.system" name="system">
      <ng-template #viewTemplate let-target>
        {{ target.system }}
      </ng-template>
      <ng-template #editTemplate let-target>
        <input nz-input name="system" [(ngModel)]="target.system" required />
      </ng-template>
    </hw-flex-editable-column>
    <hw-flex-editable-column title="mdm.obs-def-02.targets.value" name="value">
      <ng-template #viewTemplate let-target>
        {{ target.value }}
      </ng-template>
      <ng-template #editTemplate let-target>
        <input nz-input name="value" [(ngModel)]="target.value" required />
      </ng-template>
    </hw-flex-editable-column>
    <hw-flex-editable-column title="mdm.obs-def-02.targets.factor" name="factor">
      <ng-template #viewTemplate let-target>
        {{ target.factor }}
      </ng-template>
      <ng-template #editTemplate let-target>
        <input nz-input name="factor" [(ngModel)]="target.factor" required />
      </ng-template>
    </hw-flex-editable-column>
  </hw-flex-editable-table>
</form>
